const standardColors = [
    'var(--spinner-light-color)',
    'var(--spinner-dark-color)',
    'var(--spinner-pastel-color)',
    'var(--spinner-medium-color)',
];
const constitutionDayColors = [
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#FFFFFF',
    '#00205b',
    '#00205b',
    '#FFFFFF',
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#FFFFFF',
    '#00205b',
    '#00205b',
    '#FFFFFF',
];
const prideColors = ['#ED3333', '#FFA533', '#FFF133', '#349A4E', '#3370FF', '#9233A0'];
export const getType = () => Array.from(document.documentElement.classList)
    .find((className) => className.startsWith('sgw-loader--'))
    ?.replace('sgw-loader--', '');
export const getColors = () => {
    switch (getType()) {
        case 'pride':
            return prideColors;
        case 'constitution-day':
            return constitutionDayColors;
        default:
            return standardColors;
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3Bpbm5lclV0aWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9AZWlrYS9sb2FkZXIvc3JjL3NwaW5uZXJVdGlsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sY0FBYyxHQUFHO0lBQ25CLDRCQUE0QjtJQUM1QiwyQkFBMkI7SUFDM0IsNkJBQTZCO0lBQzdCLDZCQUE2QjtDQUNoQyxDQUFDO0FBRUYsTUFBTSxxQkFBcUIsR0FBRztJQUMxQixTQUFTO0lBQ1QsU0FBUztJQUNULFNBQVM7SUFDVCxTQUFTO0lBQ1QsU0FBUztJQUNULFNBQVM7SUFDVCxTQUFTO0lBQ1QsU0FBUztJQUNULFNBQVM7SUFDVCxTQUFTO0lBQ1QsU0FBUztJQUNULFNBQVM7SUFDVCxTQUFTO0lBQ1QsU0FBUztJQUNULFNBQVM7SUFDVCxTQUFTO0lBQ1QsU0FBUztJQUNULFNBQVM7SUFDVCxTQUFTO0lBQ1QsU0FBUztDQUNaLENBQUM7QUFFRixNQUFNLFdBQVcsR0FBRyxDQUFDLFNBQVMsRUFBRSxTQUFTLEVBQUUsU0FBUyxFQUFFLFNBQVMsRUFBRSxTQUFTLEVBQUUsU0FBUyxDQUFDLENBQUM7QUFFdkYsTUFBTSxDQUFDLE1BQU0sT0FBTyxHQUFHLEdBQUcsRUFBRSxDQUN4QixLQUFLLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxlQUFlLENBQUMsU0FBUyxDQUFDO0tBQ3pDLElBQUksQ0FBQyxDQUFDLFNBQVMsRUFBRSxFQUFFLENBQUMsU0FBUyxDQUFDLFVBQVUsQ0FBQyxjQUFjLENBQUMsQ0FBQztJQUMxRCxFQUFFLE9BQU8sQ0FBQyxjQUFjLEVBQUUsRUFBRSxDQUFDLENBQUM7QUFFdEMsTUFBTSxDQUFDLE1BQU0sU0FBUyxHQUFHLEdBQUcsRUFBRTtJQUMxQixRQUFRLE9BQU8sRUFBRSxFQUFFLENBQUM7UUFDaEIsS0FBSyxPQUFPO1lBQ1IsT0FBTyxXQUFXLENBQUM7UUFDdkIsS0FBSyxrQkFBa0I7WUFDbkIsT0FBTyxxQkFBcUIsQ0FBQztRQUNqQztZQUNJLE9BQU8sY0FBYyxDQUFDO0lBQzlCLENBQUM7QUFDTCxDQUFDLENBQUMifQ==